import { CustomForm, CustomFormGroup } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { StockMovements } from "tilby-models";

export class StockMovementsFe {
    // id: number = -1;
    date: Date = new Date();
    supplier_order: string = "";
    operator_fullname: string = "";
    supplier_name: string = "";
    movement_type: string = "";
}

export class StockMovementDetailFe {
    name: string = "";
    quantity: number = 0;
    price: number = 0;
    perc_discount: number = 0;
    row_amount: number = 0;
}

// lista piatta di movimenti, usata quando c'è una ricerca testuale
export class StockMovementSearchFe {
    name: string = "";
    quantity: number = 0;
    price: number = 0;
    perc_discount: number = 0;
    row_amount: number = 0;
    movement_type: string = "";
    date: Date = new Date();
    supplier_name: string = "";
    supplier_order: string = "";
}

export type StockMovementsFields = StockMovementsFe;

export type StockMovementsFieldsNullable = { [prop in string & keyof StockMovementsFields]: StockMovementsFields[prop] | null };
export type StockMovementsForm = Partial<CustomForm<StockMovementsFieldsNullable>>;

export type StockMovementsFormGroups = CustomFormGroup<StockMovementsForm>;

export type StockMovementType = 'allManuals' | 'all' | 'load' | 'unload' | 'unloadManual' | 'unloadSales' | 'setup';

export interface StockMovementTypeOption {
    value: StockMovementType;
    label: string;
}

export const stockMovementTypeOptions: StockMovementTypeOption[] = [
    { value: 'allManuals', label: 'STOCK.TOPBAR_STOCK.ALL_MANUAL' },
    { value: 'all', label: 'STOCK.TOPBAR_STOCK.ALL' },
    { value: 'load', label: 'STOCK.TOPBAR_STOCK.ONLY_LOAD' },
    { value: 'unload', label: 'STOCK.TOPBAR_STOCK.ONLY_UNLOAD' },
    { value: 'unloadManual', label: 'STOCK.TOPBAR_STOCK.ONLY_UNLOAD_MANUAL' },
    { value: 'unloadSales', label: 'STOCK.TOPBAR_STOCK.ONLY_UNLOAD_AUTO' },
    { value: 'setup', label: 'STOCK.TOPBAR_STOCK.ONLY_STOCK' },
];

export interface StockLocationOption {
    id: number;
    name: string;
}

export interface StockMovementsFilterFields {
    date_from: Date | null;
    date_to: Date | null;
    stock_location_id: number | null;
    movement_type: StockMovementType | null;
}

export type StockMovementsFilterForm = Partial<CustomForm<StockMovementsFilterFields>>;
export type StockMovementsFilterFormGroup = CustomFormGroup<StockMovementsFilterForm>;

export const filterableStockColumnsWithSearchBar: (keyof StockMovementsFe)[] = ["date", "supplier_order", "operator_fullname", "supplier_name", "movement_type"];

export const stockMovementsKeys: (keyof StockMovements)[] = ['date', 'type', 'supplier_id', 'supplier_order', 'stock_location_id'];